<div class="dashboard-container">

  <div class="season-selector-wrapper">
    <mat-form-field appearance="outline" class="season-selector">
      <mat-label>Temporada</mat-label>
      <mat-select
        (selectionChange)="onSeasonChange($event)"
        [disabled]="!seasons || seasons.length === 0"
        [value]="seasons?.[0]?.id">

        <mat-option *ngFor="let season of seasons" [value]="season.id">
          {{ season.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-progress-bar
    *ngIf="isLoadingStats"
    mode="indeterminate"
    class="stats-loader">
  </mat-progress-bar>

  <div *ngIf="!isLoadingStats" class="stats-grid">

    <mat-card *ngIf="!stats" class="empty-stats-card">
      <mat-card-content>
        <mat-icon>bar_chart</mat-icon>
        <span>No hay estadísticas disponibles para la temporada seleccionada.</span>
      </mat-card-content>
    </mat-card>

    <ng-container *ngIf="stats">

      <mat-card class="stat-card">
        <mat-card-header>
          <mat-card-title>Partidos Jugados</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <span class="kpi-value">{{ stats.total_matches_played }}</span>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card">
        <mat-card-header>
          <mat-card-title>Goles Totales</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <span class="kpi-value">{{ stats.total_goals }}</span>
        </mat-card-content>
      </mat-card>

      <mat-card *ngIf="stats.goals_per_match != null" class="stat-card">
        <mat-card-header>
          <mat-card-title>Goles / Partido</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <span class="kpi-value">{{ stats.goals_per_match | number: '1.1-2' }}</span>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card">
        <mat-card-header>
          <mat-card-title>Amarillas</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <span class="kpi-value">{{ stats.total_yellow_cards }}</span>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card">
        <mat-card-header>
          <mat-card-title>Exclusiones (2 min)</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <span class="kpi-value">{{ stats.total_2min_exclusions }}</span>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card">
        <mat-card-header>
          <mat-card-title>Rojas</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <span class="kpi-value">{{ stats.total_red_cards }}</span>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card">
        <mat-card-header>
          <mat-card-title>Azules</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <span class="kpi-value">{{ stats.total_blue_cards }}</span>
        </mat-card-content>
      </mat-card>

    </ng-container>
  </div>
</div>
